import script from "./AppBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./AppBreadcrumbs.vue?vue&type=style&index=0&id=49d7a232&lang=css"

const __exports__ = script;

export default __exports__